<template>
  <ol class="list" :class="{ row_list: moreRows }">
    <li
      v-for="(item, index) in list instanceof Array ? list : $tm(list)"
      class="list-item list-flex"
      :key="index"
      :style="moreRows && liStyle"
    >
      <!-- ВНУТРЕННИЙ КОНТЕНТ -->
      <div class="inner_content" :class="{ 'inner_content-flex': moreRows }">
        <div class="list_inner_content">
          <!-- НОМЕР -->
          <span class="item_number">{{ countList(index) }}</span>
          <!-- ТЕКСТ С АБЗАЦАМИ -->
          <div class="text_container" :class="{ 'text_container-flex': moreRows }">
            <!-- ТЕКСТ -->
            <span v-if="typeof item === 'string'" v-html="$t(item)"> </span>
            <!-- СПИСОК -->
            <p
              v-else
              v-for="(text, index) in item"
              :key="index"
              class="p_text"
              v-html="text"
            ></p>
          </div>
        </div>
      </div>
      <!-- СЛОТ -->
      <slot :index="index"></slot>
    </li>
  </ol>
</template>

<script setup>
import { computed } from "vue";
import { useWindowSize } from "@vueuse/core";

const countList = (i) => (i < 9 ? `0${i + 1}` : i + 1);

const { width } = useWindowSize();

const props = defineProps({
  list: {
    type: Array,
    default: () => [],
  },
  row: {
    type: Number,
    default: 1,
  },
});

const moreRows = computed(() => props.row > 1 && width.value > 800);

const liStyle = computed(() => ({ width: `calc(${100 / props.row}% - 22px)` }));
</script>

<style lang="scss" scoped>
.list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 22px;

  &-item {
    font-family: Gilroy;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    box-sizing: border-box;
    color: var(--text-second-color);
  }

  &-flex {
    display: flex;
    flex-direction: column;
    align-self: stretch;
  }
}

.list_inner_content {
  display: flex;
  align-items: center;
  gap: 10px;
}

.row_list {
  flex-direction: row;
  flex-wrap: wrap;
  /* align-items: flex-end; */
}

.inner_content {
  padding: 20px;
  border-radius: 11px;
  background: var(--block-color);

  box-shadow: 0 10px 13px rgba(122, 112, 223, 0.22);

  &-flex {
    align-items: flex-start;
    flex: 1;
  }
}

.item_number {
  align-items: center;
  align-self: baseline;
  background-color: #7a70df;
  border-radius: 50%;
  color: #fff;
  display: flex;
  flex: 0 0 40px;
  font-family: Gilroy;
  font-size: 18px;
  font-weight: 700;
  height: 40px;
  justify-content: center;
  width: 40px;
}

.text_container {
  font-family: "Gilroy";
  font-size: 16px;
  font-weight: 500;
  color: var(--text-second-color);

  &-flex {
  }
}

.p_text:not(:last-child) {
  margin-bottom: 16px;
}

@media screen and (max-width: 700px) {
  .list-item {
    width: 100%;
    font-size: 14px;
  }
}

@media screen and (max-width: 460px) {
  .list-item {
    padding: 10px;
    width: 100%;
    align-items: flex-start;
    line-height: 150%;
    font-size: 12px;
  }
}
</style>
